import { Flex } from 'antd';
import Title from 'antd/es/typography/Title';
import { CloseModalBtn } from '../buttons/CloseModalBtn';

interface RenderHeaderDesktopProps {
  headerCaption: string;
  onCancel: () => void;
  HeaderButtons?: JSX.Element;
}

const RenderHeaderDesktop: React.FC<RenderHeaderDesktopProps> = ({
  headerCaption,
  onCancel,
  HeaderButtons,
}) => {
  return (
    <>
      <Flex>
        <Title level={3} style={{ height: 'auto', margin: '0' }}>
          {headerCaption}
        </Title>
      </Flex>
      <Flex gap="small">
        {HeaderButtons}
        <CloseModalBtn onClick={onCancel} />
      </Flex>
    </>
  );
};

export default RenderHeaderDesktop;
